import React, { useState, useEffect } from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  CircularProgress,
  Button,
  Box
} from '@mui/material';
import PasswordIcon from '@mui/icons-material/Password';
import PropTypes from 'prop-types';
import LoadingProgress from 'src/components/app/LoadingProgress';
import Error from 'src/components/app/Error';
import ShopifyList from 'src/components/shopify/ShopifyList';
import PluginCard from './PluginCard';
import ApiKeyDialog from './ApiKeyDialog';
import $api from '../http';
import { useTranslation } from 'react-i18next';
import { useAppConext } from '../context/AppContext';
import RestrictedFieldWrapper from '../app/RestrictedFieldWrapper';

const WidgetCodeConfig = (props) => {
  const { t } = useTranslation();
  const [loadError, setLoadError] = useState({});
  const [isPluginsLoaded, setIsPluginsLoaded] = useState(false);
  const [plugins, setPlugins] = useState([]);
  const [apiDialogOpen, setApiDialogOpen] = useState(false);
  const { getFeatureValue } = useAppConext();

  const { pluginsUrl } = props;

  const loadPlugins = () => {
    $api.get(pluginsUrl)
      .catch((e) => {
        setLoadError(e);
        return null;
      })
      .then((result) => {
        if (result && result.data) {
          setPlugins(result.data);
        }
        setIsPluginsLoaded(true);
      });
  };

  const handleApiKeyClick = () => {
    setApiDialogOpen(true);
  };

  useEffect(() => {
    loadPlugins();
  }, []);

  if (!isPluginsLoaded) {
    return (<LoadingProgress open />);
  }
  if (loadError && Object.keys(loadError).length !== 0) {
    return (
      <Error error={loadError} />
    );
  }
  return (
    <RestrictedFieldWrapper restricted={!getFeatureValue('apps.enabled')} fullWidth>
      <Card>
        <CardHeader
          title={t('Apps and plugins')}
          sx={{
            '& .MuiCardHeader-action': {
              my: 'auto'
            }
          }}
          action={(
            <Box sx={{ flexGrow: 1, textAlign: 'right' }}>
              <Button variant="contained" startIcon={<PasswordIcon />} onClick={handleApiKeyClick}>
                {t('Your API key')}
              </Button>
            </Box>
          )}
        />
        <Divider />
        <CardContent>
        <ShopifyList />
            <Grid
              container
              spacing={3}
            >
              {(!isPluginsLoaded) && (
                <CircularProgress />
              )}
              {(isPluginsLoaded) && (
                (plugins.map((plugin) => (
                  <Grid
                    item
                    key={plugin.id}
                    xl={3}
                    lg={4}
                    md={6}
                    sm={6}
                    xs={12}
                    sx={{
                      '& > .MuiBox-root': {
                        height: '100%'
                      }
                    }}
                  >
                    <RestrictedFieldWrapper restricted={!getFeatureValue(`apps.${plugin.name}`)} fullWidth>
                      <PluginCard plugin={plugin} />
                    </RestrictedFieldWrapper>
                  </Grid>
                )))
              )}
            </Grid>
        <ApiKeyDialog open={apiDialogOpen} onClose={() => { setApiDialogOpen(false); }} />
      </CardContent>
      </Card>
      </RestrictedFieldWrapper>
  );
};

WidgetCodeConfig.propTypes = {
  pluginsUrl: PropTypes.string
};

export default WidgetCodeConfig;
